import React from 'react';
import { motion } from 'framer-motion';
import { Users, ArrowRight, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import '../styles/design-system.css';

const ProjectsSection = () => {
  const { projectsData } = useLanguage();
  const handleNavClick = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: 'easeOut' }
    }
  };

  return (
    <section 
      id="projects" 
      className="py-20 md:py-32"
      style={{ background: 'var(--bg-page)' }}
    >
      <div className="container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="heading-hero mb-4">{projectsData.title}</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto' }}>
            {projectsData.subtitle}
          </p>
        </motion.div>

        {/* Projects Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {projectsData.projects.map((project) => (
            <motion.div
              key={project.id}
              variants={cardVariants}
              className={`voice-card accent-${project.accent} flex flex-col h-full relative overflow-hidden`}
            >
              {/* Decorative Element */}
              <div 
                className="absolute top-0 right-0 w-24 h-24 rounded-full blur-2xl opacity-30"
                style={{ background: `var(--accent-${project.accent}-200)` }}
              />

              <div className="flex-1 relative z-10">
                {/* Project Badge */}
                <div className="flex items-center gap-2 mb-4">
                  <Star size={16} style={{ color: 'var(--text-primary)' }} />
                  <span className="mono-text">{project.tagline}</span>
                </div>

                <h3 className="voice-card-title text-xl mb-3">{project.name}</h3>
                <p className="voice-card-description">{project.description}</p>
                
                {/* Audience */}
                <div className="mt-4 flex items-start gap-2">
                  <Users size={16} className="flex-shrink-0 mt-0.5" style={{ color: 'var(--text-muted)' }} />
                  <span className="caption">{project.audience}</span>
                </div>
              </div>

              {/* CTA Button */}
              <Link
                to="/em-construcao"
                className="btn-secondary mt-6 w-full flex items-center justify-center gap-2 text-decoration-none"
              >
                Participe
                <ArrowRight size={14} />
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProjectsSection;
